import { jsxs as _jsxs, jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { renderBinaryRadioButtonGroup } from '../../ui-kit/Calculator/renderBinaryRadioButtonGroup.js';
import { renderPayout } from '../../ui-kit/Calculator/renderPayout.js';
import { Checkbox } from '../../ui-kit/Checkbox/Checkbox.js';
import { renderRegistrationType } from './renderRegistrationType.js';
export const renderDepositParamsForm = (params, field) => {
    const isCurrency = params?.currency?.key !== 'rub';
    return (_jsxs("div", { className: "grid gap-lg", children: [_jsxs("div", { className: "flex gap-lg", children: [params.isShowReplenish
                        ? renderBinaryRadioButtonGroup({
                            title: 'Пополнение',
                            ...field('isReplenish'),
                            value: params.isReplenish,
                            orientation: 'vertical',
                            items: [
                                { id: 'withReplenish', text: 'С пополнением' },
                                { id: 'withoutReplenish', text: 'Без пополнения' },
                            ],
                            disabled: isCurrency,
                        })
                        : null, params.isShowWithdrawn
                        ? renderBinaryRadioButtonGroup({
                            title: 'Снятие',
                            ...field('isWithdrawn'),
                            value: params.isWithdrawn,
                            orientation: 'vertical',
                            items: [
                                { id: 'wthDrawn', text: 'Со снятием' },
                                { id: 'noWithdrawn', text: 'Без снятия' },
                            ],
                            disabled: isCurrency,
                        })
                        : null] }), renderSeparator(params.isShowReplenish || params.isShowWithdrawn), _jsxs("div", { className: "flex gap-lg", children: [params.isShowMonthlyInterestPayment
                        ? renderPayout({
                            title: 'Выплата процентов',
                            ...field('isMonthlyInterestPayment'),
                            value: params.isMonthlyInterestPayment,
                            orientation: 'vertical',
                        })
                        : null, params.isShowRemoteRegistration
                        ? renderRegistrationType({
                            title: 'Оформление',
                            ...field('isRemoteRegistration'),
                            value: params.isRemoteRegistration,
                            orientation: 'vertical',
                        })
                        : null] }), renderSeparator(params.isShowNewClient), params.isShowNewClient ? _jsx(Checkbox, { text: "\u041D\u043E\u0432\u044B\u0439 \u0432\u043A\u043B\u0430\u0434\u0447\u0438\u043A", ...field('isNewClient') }) : null] }));
};
const renderSeparator = (isShow = false) => isShow ? _jsx("div", { className: "border-b border-main-divider w-full" }) : null;
//# sourceMappingURL=renderDepositParamsForm.js.map